<template>
  <v-container
    id="data-tables"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers.filter(a => a.show || a.active)"
              :items="items"
              :footer-props="datatable_footer"
              :loading="loading"
              no-data-text="Нет данных для отображения"
              @click:row="open"
            >
              <template v-slot:footer.page-text="{pageStart, pageStop, itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        sm="2"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="$refs.filter.open()"
                        >
                          <v-icon class="ml-3">
                            mdi-filter-variant
                          </v-icon>
                          <span class="mx-3">Фильтры</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="3"
                        class="d-sm-flex justify-end"
                        offset-sm="2"
                      >
                        <v-btn
                          color="primary"
                          @click="$refs.create.open()"
                        >
                          <v-icon class="ml-3">
                            mdi-plus
                          </v-icon>
                          <span class="mx-3">Создать гостя</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="1"
                        class="d-sm-flex justify-center"
                      >
                        <v-icon
                          medium
                          class="icon-table"
                          @click="openSkudHeaders()"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="1"
                        class="d-sm-flex justify-center"
                      >
                        <v-icon
                          medium
                          class="icon-table"
                          @click="load()"
                        >
                          mdi-refresh
                        </v-icon>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12">
                        <v-alert
                          v-if="items.length >= 500"
                          type="warning"
                          dense
                          outlined
                          class="mb-0"
                        >
                          Показаны первые 500 записей, сузьте фильтры.
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.visitor_name="{item}">
                <span v-if="item.name_erased_at">удалено (retention)</span>
                <span v-else>{{ item.visitor_name }}</span>
              </template>
              <template v-slot:item.state_text="{item}">
                <v-chip
                  small
                  :color="item.state_color"
                  dark
                >
                  {{ item.state_text }}
                </v-chip>
              </template>
              <template v-slot:item.actions="{item}">
                <skud-actions-menu v-if="item.state === 0">
                  <v-list-item @click="openRevoke(item)">
                    <v-list-item-content>
                      Отозвать
                    </v-list-item-content>
                  </v-list-item>
                </skud-actions-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <skud-filter-dialog
      ref="filter"
      :fields="filter_fields"
      storage-key="skud.guest"
      @apply="onFilterApply"
    />

    <skud-guest-create-dialog
      ref="create"
      @saved="load()"
    />

    <v-dialog
      v-model="revoke_dialog.show"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Отозвать гостевой пропуск</span>
        </v-card-title>
        <v-card-text>
          <div class="mb-3">
            Пропуск {{ revoke_dialog.item ? revoke_dialog.item.code : '' }} будет отозван.
          </div>
          <v-text-field
            v-model="revoke_dialog.reason"
            label="Причина (необязательно)"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            :loading="revoke_dialog.loading"
            @click="revoke()"
          >
            <span class="mx-4">Отозвать</span>
          </v-btn>
          <v-btn
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="revoke_dialog.show = false"
          >
            <span class="mx-4">Отмена</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_headers.show"
      persistent
      max-width="900px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Настройка столбцов</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :items-per-page="5"
            dense
            :items="headers.filter(a => !a.show)"
            :headers="[{value: 'text', text: 'Название столбца'}, {value: 'active_temp', text: 'Отображение'}]"
            :footer-props="datatable_footer"
            no-data-text="Нет данных для отображения"
          >
            <template v-slot:footer.page-text="{pageStart, pageStop, itemsLength}">
              {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
            </template>
            <template v-slot:item.active_temp="{item}">
              <v-checkbox v-model="item.active_temp" />
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="saveSkudHeaders('skud_guest')"
          >
            <span class="mx-10">Сохранить</span>
          </v-btn>
          <v-btn
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="dialog_headers.show = false"
          >
            <span class="mx-10">Закрыть</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Список гостевых пропусков СКУД. Серверной пагинации нет (лимит 500 на сервере),
// таблица клиентская. Фильтры: период (по ValidFrom) + состояние, хранятся в localStorage 'skud.guest'.
import { headersMixin } from '@/views/skud/shared/modules/headers-mixin'
import { GuestPassState, enumOptions } from '@/views/skud/shared/models/enums'
import { SkudGuestService } from '@/views/skud/shared/services/skud-guest-service'
import SkudFilterDialog from '@/views/skud/components/SkudFilterDialog.vue'
import SkudGuestCreateDialog from '@/views/skud/components/SkudGuestCreateDialog.vue'
import SkudActionsMenu from '@/views/skud/components/SkudActionsMenu.vue'

export default {
  name: 'SkudGuestList',
  components: { SkudFilterDialog, SkudGuestCreateDialog, SkudActionsMenu },
  mixins: [headersMixin],
  data: () => ({
    svc: null,
    items: [],
    loading: false,
    filter: {},
    revoke_dialog: { show: false, item: null, reason: '', loading: false },
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageOptions: [5, 10, 15, 30, 50]
    },
    filter_fields: {
      common: {
        index: 0,
        name: 'Основное',
        data: [
          { name: 'Действует с', field: 'from', type: 'date' },
          { name: 'Действует по', field: 'to', type: 'date' },
          { name: 'Состояние', field: 'state', type: 'select', select: enumOptions(GuestPassState) }
        ]
      }
    },
    headers: [
      { text: 'Действия', value: 'actions', show: true, sortable: false },
      { text: 'Код', value: 'code', show: true },
      { text: 'Место', value: 'place_name', active: true, active_temp: true },
      { text: 'Посетитель', value: 'visitor_name', active: true, active_temp: true },
      { text: 'Состояние', value: 'state_text', active: true, active_temp: true },
      { text: 'Действует с', value: 'valid_from', active: true, active_temp: true },
      { text: 'Действует по', value: 'valid_to', active: true, active_temp: true },
      { text: 'Проходов всего', value: 'uses_total', active: true, active_temp: true },
      { text: 'Проходов осталось', value: 'uses_left', active: true, active_temp: true },
      { text: 'Цель', value: 'purpose', active: true, active_temp: true },
      { text: 'Отозван', value: 'revoked_at', active: true, active_temp: true },
      { text: 'Создан', value: 'created_at', active: true, active_temp: true },
      { text: 'Кем создан', value: 'created_by', active: true, active_temp: true },
      { text: 'Public ID', value: 'public_id', active: true, active_temp: true }
    ]
  }),
  mounted () {
    this.svc = new SkudGuestService()
    this.filter = this.$refs.filter.current()
    this.setDefaultSkudHeaders(this.$store.state.user.skud_guest_headers)
    this.load()
  },
  methods: {
    reset () {
      this.items = []
    },
    async load () {
      this.loading = true
      this.items = await this.svc.getGuests(null, this.filter)
      this.loading = false
    },
    onFilterApply (values) {
      this.filter = values
      this.reset()
      this.load()
    },
    open (item) {
      this.$router.push({ path: this.$route.path.replace(/list$/, 'view'), query: { id: item.public_id, place: item.place_id } })
    },
    openRevoke (item) {
      this.revoke_dialog.item = item
      this.revoke_dialog.reason = ''
      this.revoke_dialog.show = true
    },
    async revoke () {
      this.revoke_dialog.loading = true
      const body = { public_id: this.revoke_dialog.item.public_id }
      if (this.revoke_dialog.reason) body.reason = this.revoke_dialog.reason
      const r = await this.svc.revokeGuest(this.revoke_dialog.item.place_id, body)
      this.revoke_dialog.loading = false
      this.revoke_dialog.show = false
      if (r.ok) {
        this.$store.commit('snackbar', 'Гостевой пропуск отозван')
        this.load()
      } else {
        this.$store.commit('snackbar', r.error || 'Ошибка при отзыве')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-table {
  height: 30px;
  width: 30px;
  margin-top: 3px;
  margin-left: 8px;
  color: grey;
  &:hover {
    color: #315bbf;
  }
}
</style>
